module.exports = __webpack_public_path__ + "static/media/rododendrs.d0ed63b8.jpg";